"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classnames = require("classnames");
var Utils = require("player-core/utils");
var utils_1 = require("../utils");
var _1 = require("./");
var EnhancedInput = utils_1.compose({
    description: true,
    enterKey: true,
    label: true,
    icons: true,
})(_1.Input);
var EnhancedTextarea = utils_1.compose({
    autogrow: true,
    description: true,
    label: true,
})(_1.Textarea);
var Textbox = (function (_super) {
    __extends(Textbox, _super);
    function Textbox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._id = _this.props.id ? _this.props.id : 'inp' + Utils.createUUID();
        _this._heights = {
            'Xsmall': {
                className: 'row-1',
                rows: 0
            },
            'Small': {
                className: 'row-3',
                rows: 3
            },
            'Medium': {
                className: 'row-6',
                rows: 6
            },
            'Large': {
                className: 'row-9',
                rows: 9
            }
        };
        _this._isTextarea = _this._heights[_this.props.height].rows > 1
            || _this.props.autogrow
            || _this.props.scrollable;
        _this._textareaProps = {
            autogrow: _this.props.autogrow,
            isResizable: _this.props.isResizable,
            isScrollable: _this.props.scrollable,
            textareaRef: _this.props.onRef,
        };
        _this._getInputProps = function () {
            return {
                leftIcon: _this.props.iconLeft,
                rightIcon: _this.props.iconRight,
                onEnter: _this.props.onEnter && _this._onEnter,
                onKeyDown: _this._onKeyDown,
                inputRef: _this.props.onRef,
            };
        };
        _this._getCommonProps = function () {
            var _a = _this.props, ariaLabel = _a.ariaLabel, ariaLabeledBy = _a.ariaLabeledBy, defaultValue = _a.defaultValue, description = _a.description, errorMessage = _a.errorMessage, errorComponent = _a.errorComponent, errorClassname = _a.errorClassname, height = _a.height, isControlled = _a.isControlled, isEnabled = _a.isEnabled, isRequired = _a.isRequired, label = _a.label, maxLength = _a.maxLength, onChange = _a.onChange, onBlur = _a.onBlur, onFocus = _a.onFocus, placeholder = _a.placeholder, showLabel = _a.showLabel, tag = _a.tag, type = _a.type, value = _a.value, autoComplete = _a.autoComplete, ariaDescribedBy = _a.ariaDescribedBy;
            var _b = _this._heights[height], rows = _b.rows, className = _b.className;
            var valueProp = isControlled ? { value: value } : { defaultValue: defaultValue };
            var containerClassNames = classnames('form-row', {
                'is-required': isRequired,
                'is-invalid': !!errorMessage,
            });
            return __assign({ 
                // This is supported when composing
                'tag': tag, 'containerClassName': containerClassNames, 
                // These are supported by withDescription()
                'description': description, 'errorMessage': errorMessage, 'hasError': !!errorMessage, 
                // These are supported by withLabel()
                'id': _this._id, 'label': label, 'showLabel': showLabel, 
                // These are supported by the base
                'aria-disabled': !isEnabled, 'aria-invalid': !!errorMessage, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabeledBy, 'aria-required': isRequired, 'className': className, 'disabled': !isEnabled, 'maxLength': maxLength, 'onBlur': onBlur && _this._onBlur, 'onChange': onChange && _this._onChange, 'onFocus': onFocus && _this._onFocus, 'placeholder': placeholder, 'required': isRequired, 'rows': rows, 'type': type, 'errorComponent': errorComponent, 'errorClassname': errorClassname, 'autoComplete': autoComplete, 'aria-describedby': ariaDescribedBy }, valueProp);
        };
        _this._onChange = function (event) {
            var value = event.target.value;
            _this.props.onChange && _this.props.onChange(value, _this._id);
        };
        _this._onFocus = function (event) {
            var value = event.target.value;
            _this.props.onFocus && _this.props.onFocus(value, _this._id, event);
        };
        _this._onBlur = function (event) {
            var value = event.target.value;
            _this.props.onBlur && _this.props.onBlur(value, _this._id);
        };
        _this._onEnter = function (event) {
            var value = event.target.value;
            _this.props.onEnter && _this.props.onEnter(value, _this._id);
        };
        _this._onKeyDown = function (event) {
            var target = event.target;
            var value = target.value;
            var key = event.key;
            if (key.toLowerCase() == "backspace") {
                value = value.slice(0, -1);
                key = "";
            }
            var usingArrows = key.toLowerCase() in { "arrowup": 1, "arrowdown": 1, "arrowleft": 1, "arrowright": 1 };
            if (!usingArrows && (_this.props.type || '').toLowerCase() === 'number' && !/^[0-9]*[\.,]?[0-9]*$/.test(value + key)) {
                event.preventDefault();
                return;
            }
            _this.props.onKeyDown && _this.props.onKeyDown(value, _this._id);
        };
        return _this;
    }
    Textbox.prototype.render = function () {
        return this._isTextarea
            ? React.createElement(EnhancedTextarea, __assign({}, this._getCommonProps(), this._textareaProps))
            : React.createElement(EnhancedInput, __assign({}, this._getCommonProps(), this._getInputProps()));
    };
    return Textbox;
}(React.PureComponent));
Textbox.defaultProps = {
    label: 'Label',
    isControlled: true,
    type: 'Text',
    height: 'Xsmall',
    autogrow: false,
    scrollable: false,
    isRequired: false,
    isResizable: true,
    showLabel: true,
    isEnabled: true,
    errorClassname: '',
    errorComponent: undefined,
    autoComplete: undefined
};
exports.Textbox = Textbox;
exports.default = Textbox;
//# sourceMappingURL=Textbox.js.map


//////////////////
// WEBPACK FOOTER
// ../player-textbox/build/control/components/Textbox.js
// module id = 157
// module chunks = 0 1 2